<template>
  <VCard :color="backgroundColor">
    <VBlock class="product-wrapper" :direction="Direction.column" :sort="Sort.left_center">
      <VP
        class="title"
        :text="product.getName()"
        :size="21"
        :weight="TextWeight.bold"
        :color="!product.isUnpurchasable() ? TextColor.darkGray : TextColor.inactive"
      />
      <VList class="list">
        <VListItem
          class="list-item-wrapper"
          v-for="(item, index) in product.getItems()"
          :key="index"
        >
          <MarketItem
            class="list-item"
            :index="index"
            :name="item.getName()"
            :checked="item.getChecked()"
            :disabled="item.getDisabled()"
            :image="item.getImage()"
            :soldOut="item.getSoldOut()"
            :notFirstPurchase="item.getNotFirstPurchase()"
            :notFirstPurchaseGuest="item.getNotFirstPurchaseGuest()"
            :firstPurchaseOnlyProduct="item.getFirstPurchaseOnlyProduct()"
            :isPurchasable="item.isPurchasable()"
            :isUnpurchasable="item.isUnpurchasable()"
            :stockCount="item.getStockCount()"
            :retailPrice="item.getRetailPrice()"
            :salePrice="item.getSalePrice()"
            :quantity="item.getQuantity()"
            :minCount="item.getMinCount()"
            :maxCount="item.getMaxCount()"
            :returnOrExchange="product.getReturnOrExchange()"
            :locked="item.getLocked()"
            :onChecked="() => { onChecked(item, index) }"
            :onDelete="() => { onDelete(product, item) }"
            :onMoveDetail="() => { onMoveDetail(product, item) }"
          >
            <CartProductQuantity
              v-if="!product.getReturnOrExchange() && !item.getFirstPurchaseOnlyProduct()"
              :product="product"
              :item="item"
              :onAddQuantity="onAddEvent"
              :onSubQuantity="onSubEvent"
            />
            <VA
              v-if="!product.getReturnOrExchange() && item.getFirstPurchaseOnlyProduct()"
              :onClick="onMoveFirstPurchase"
            >
              <VBlock :sort="Sort.left_center">
                <VBlock class="show-another-products" :padding="[10, 10, 10, 13]">
                  <VBlock
                    class="text-wrapper"
                    :style="{ transform: isAndroid ? '' : 'translateY(1px)' }"
                  >
                    <VSpan class="text" text="다른상품 보기" :size="14" />
                  </VBlock>
                  <VBlock class="icon-wrapper">
                    <VImage :width="14" :height="14" class="icon" :src="resources.RightArrowIcon" />
                  </VBlock>
                </VBlock>
              </VBlock>
            </VA>
          </MarketItem>
          <VHR
            :color="LineColor.gray2"
            class="market-item-hr"
            v-if="index < product.getItems().length - 1"
          />
        </VListItem>
      </VList>
      <CartFreeGift v-if="product.isPurchasable()" :freeGifts="product.getOptions()" />
    </VBlock>
  </VCard>
</template>

<script>
import VP, { TextWeight, TextColor } from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'

import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VA from '@/presentationals/v2/components/layouts/molecules/VA'
import VCard, { ColorType } from '@/presentationals/v2/components/layouts/molecules/VCard'
import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'

import VHR, { LineColor } from '@/presentationals/v2/components/layouts/atoms/VHR'

import MarketItem from '@/presentationals/v2/components/layouts/organisms/MarketItem'

import CartFreeGift from '../CartFreeGift'

import CartProductQuantity from './CartProductQuantity'
import RightArrowIcon from '@/assets/images/right-arrow.svg'

export default {
  name: 'CartProduct',
  components: {
    VP,
    VSpan,
    VHR,
    VImage,

    VA,
    VBlock,
    VCard,
    VList,
    VListItem,

    MarketItem,

    CartProductQuantity,
    CartFreeGift
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    onDelete: {
      type: Function,
      required: true
    },
    onChecked: {
      type: Function
    },
    onAddQuantity: {
      type: Function
    },
    onSubQuantity: {
      type: Function
    },
    onMoveDetail: {
      type: Function
    },
    onMoveFirstPurchase: {
      type: Function
    }
  },
  computed: {
    backgroundColor() {
      return ColorType.white
    },
    isAndroid() {
      return this.$store.getters.isAndroid
    }
  },
  methods: {
    async onAddEvent(product, item) {
      await this.onAddQuantity(product, item)
    },
    async onSubEvent(product, item) {
      await this.onSubQuantity(product, item)
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextWeight,
      ColorType,
      LineColor,
      TextColor,

      resources: {
        RightArrowIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.product-wrapper {
  .title {
    display: block;
    width: 100%;
    padding: 0 16px 0 16px;
    margin-top: 25px;
    box-sizing: border-box;
    text-align: left;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .list {
    .list-item-wrapper {
      padding: 0 15px 0 15px;
      box-sizing: border-box;

      .list-item {
        padding: 15px 0 8px 0;
        box-sizing: border-box;

        & .show-another-products {
          width: auto;
          align-content: center;
          align-self: center;
          height: 36px;
          box-sizing: border-box;
          border: 1px solid #ccc;
          border-radius: 18px;

          & .icon-wrapper {
            width: 18px;
            height: 18px;

            & .icon {
              width: 14px;
              height: 14px;
            }
          }

          // & .another-text {
          //   height: 17px;

          & .text-wrapper {
            height: 18px;

            & .text {
              line-height: 0.8;
              vertical-align: middle;
              margin-right: 4px;
            }
          }

          // }
        }
      }
    }
  }
}
</style>